import AbstractModel, { Model, DateType } from './abstract-model';
import {LexPocSuivi} from "./gen-lexs";

@Model('CavPocSuivi')
export default class CavPocSuivi extends AbstractModel {
  public id: number = null;
  public idCavite: string = null;
  @DateType() public quand: Date = null;
  public lexPocTypeSuivi: LexPocSuivi = null;
  public commentaire: string = null;
}
